import React from "react";

import { Container } from "./style";
import Gallary from "../Tabs/Tabs";
export default function Classes() {
  return (
    <Container id="classes">
      <Gallary />
    </Container>
  );
}
